export const BluePrintState = [
  {
    Name: 'Initiated',
    Value: 'Initiated',
    Id: 0,
    Color: '#00BCD4',
    LblClass: 'lbl-initiated',
    ForeColor: '#ffffff',
    isCatalog: true,
    shouldDisplayInJobs: true
  },
  {
    Name: 'PendingApproval',
    Value: 'Pending Approval',
    LblClass: 'lbl-pending-approval',
    Id: 1,
    Color: '#ffc107',
    ForeColor: '#000000',
    isCatalog: true,
    shouldDisplayInJobs: true
  },
  {
    Name: 'Approved',
    Value: 'Approved',
    Id: 2,
    Color: '#4caf50',
    LblClass: 'lbl-approved',
    ForeColor: '#ffffff',
    isCatalog: true,
    shouldDisplayInJobs: true
  },
  {
    Name: 'DeploymentInProgress',
    Value: 'Deployment in Progress',
    Id: 3,
    Color: '#22ffd6',
    LblClass: 'lbl-running',
    ForeColor: '#000000',
    isCatalog: false,
    shouldDisplayInJobs: true
  },
  {
    Name: 'Operational',
    Value: 'Operational',
    Id: 4,
    Color: '#22ffd6',
    LblClass: 'lbl-running',
    ForeColor: '#000000',
    isCatalog: false,
    shouldDisplayInJobs: true
  },
  {
    Name: 'Rejected',
    Value: 'Rejected',
    Id: 5,
    LblClass: 'lbl-rejected',
    Color: '#9C27B0',
    ForeColor: '#ffffff',
    isCatalog: true,
    shouldDisplayInJobs: true
  },
  {
    Name: 'Deleted',
    Value: 'Deleted',
    Id: 6,
    LblClass: 'lbl-delete',
    Color: '#F44336',
    ForeColor: '#ffffff',
    isCatalog: true,
    shouldDisplayInJobs: true
  },
  {
    Name: 'ErrorOnCloud',
    Value: 'Error',
    Id: 7,
    Color: '#ec2d2d',
    LblClass: 'lbl-delete',
    ForeColor: '#ffffff',
    isCatalog: false,
    shouldDisplayInJobs: true
  },
  {
    Name: 'SyncInProgress',
    Value: 'Sync in Progress',
    Id: 8,
    Color: '#22ccff',
    LblClass: 'lbl-sync',
    ForeColor: '#ffffff',
    isCatalog: false,
    shouldDisplayInJobs: false
  },
  {
    Name: 'OutOfSync',
    Value: 'Out of Sync',
    Id: 9,
    Color: '#ec2d2d',
    LblClass: 'lbl-delete',
    ForeColor: '#ffffff',
    isCatalog: false,
    shouldDisplayInJobs: false
  },
  {
    Name: 'Operational(Drifted)',
    Value: 'Operational (Drifted)',
    Id: 10,
    Color: '#22ffd6',
    LblClass: 'lbl-delete',
    ForeColor: '#000000',
    isCatalog: false,
    shouldDisplayInJobs: false
  },
  {
    Name: 'DeleteInProgress',
    Value: 'Delete in Progress',
    Id: 11,
    LblClass: 'lbl-delete',
    Color: '#F44336',
    ForeColor: '#ffffff',
    isCatalog: false,
    shouldDisplayInJobs: true
  },
  {
    Name: 'InQueue',
    Value: 'In Queue',
    Id: 12,
    Color: '#22ccff',
    LblClass: 'lbl-sync',
    ForeColor: '#ffffff',
    isCatalog: false,
    shouldDisplayInJobs: true
  },
  {
    Name: 'DeleteInQueue',
    Value: 'Delete in Queue',
    Id: 13,
    LblClass: 'lbl-delete',
    Color: '#F44336',
    ForeColor: '#ffffff',
    isCatalog: false,
    shouldDisplayInJobs: true
  },
  {
    Name: 'Locked',
    Value: 'Locked',
    Id: 14,
    LblClass: 'lbl-delete',
    Color: '#F44336',
    ForeColor: '#ffffff',
    isCatalog: false,
    shouldDisplayInJobs: true
  },
  {
    Name: 'NeedsAttention',
    Value: 'Needs Attention!',
    Id: 15,
    LblClass: 'lbl-delete',
    Color: '#F44336',
    ForeColor: '#ffffff',
    isCatalog: false,
    shouldDisplayInJobs: false
  },
  {
    Name: 'ErrorOnDelete',
    Value: 'Error on Delete',
    Id: 16,
    LblClass: 'lbl-delete',
    Color: '#F44336',
    ForeColor: '#ffffff',
    isCatalog: false,
    shouldDisplayInJobs: true
  },
  {
    Name: 'Skipped',
    Value: 'Skipped',
    Id: 17,
    LblClass: 'lbl-pending-approval',
    Color: '#ffc107',
    ForeColor: '#000000',
    isCatalog: false,
    shouldDisplayInJobs: true
  },
  {
    Name: 'ConflictDetected',
    Value: 'Conflict Detected',
    Id: 18,
    LblClass: 'lbl-delete',
    Color: '#F44336',
    ForeColor: '#ffffff',
    isCatalog: false,
    shouldDisplayInJobs: true
  }
];

export const BluePrintErrorState = [
  { Name: 'Pending', Value: 'Pending', Id: 0, Color: '#FFC107', ForeColor: 'Black' }, // Amber
  { Name: 'Resolved', Value: 'Resolved', Id: 1, Color: '#4CAF50', ForeColor: 'White' }, // Green
  { Name: 'Suppressed', Value: 'Suppressed', Id: 2, Color: '#808080', ForeColor: 'Black' }
];

export const BluePrintErrorType = [
  { Name: 'Warning', Value: 'Warning', Id: 0, Color: 'rgb(255, 152, 0)', ForeColor: 'White' }, //Orange
  { Name: 'Error', Value: 'Error', Id: 1, Color: '#f44336', ForeColor: 'White' }, //red
  { Name: 'Information', Value: 'Information', Id: 2, Color: '#00bcd4', ForeColor: 'White' } //Gray   ebebee
];

export const BluePrintErrorSource = [
  { Name: 'CloudConnect', Value: 'Cloud Connect', Id: 0, Color: '#9c27b0', ForeColor: 'White' }, //Green
  { Name: 'Provisioning', Value: 'Provisioning', Id: 1, Color: '#9c27b0', ForeColor: 'White' }, //Amber
  { Name: 'Migration', Value: 'Migration', Id: 2, Color: '#9c27b0', ForeColor: 'White' }, //Cyan
  { Name: 'Discovery', Value: 'Discovery', Id: 3, Color: '#9c27b0', ForeColor: 'White' }, // Teal
  { Name: 'SyncService', Value: 'Sync Service', Id: 4, Color: '#9c27b0', ForeColor: 'White' } // Light Blue
];

export const UserRole = [{ Id: '7672ddda-ba94-49d4-8985-f92a100826a6', Name: 'Reviewer' }];

export const WorkflowTaskState = [
  {
    Name: 'PendingApproval',
    Value: 'Pending Approval',
    LblClass: 'lbl-pending-approval',
    Id: 0,
    Color: '#ffc107',
    ForeColor: '#000000',
    isCatalog: true,
    Message: 'Waiting for approval before execution can begin.'
  },
  {
    Name: 'Approved',
    Value: 'Approved',
    Id: 1,
    Color: '#4caf50',
    LblClass: 'lbl-approved',
    ForeColor: '#ffffff',
    isCatalog: true,
    Message: 'Task approved successfully. It will be executed shortly.'
  },
  {
    Name: 'PendingExecution',
    Value: 'Pending Execution',
    LblClass: 'lbl-pending-approval',
    Id: 2,
    Color: '#ffc107',
    ForeColor: '#000000',
    isCatalog: true,
    Message: 'Task is approved and pending execution.'
  },
  {
    Name: 'InQueue',
    Value: 'In Queue',
    Id: 3,
    Color: '#00BCD4',
    LblClass: 'lbl-initiated',
    ForeColor: '#ffffff',
    isCatalog: true,
    Message: 'Task is in queue and will start shortly.'
  },
  {
    Name: 'InProgress',
    Value: 'In Progress',
    Id: 4,
    Color: '#00BCD4',
    LblClass: 'lbl-initiated',
    ForeColor: '#ffffff',
    isCatalog: true,
    Message: 'Task is currently in progress. Logs will appear shortly.'
  },
  {
    Name: 'Completed',
    Value: 'Completed',
    Id: 5,
    Color: '#4caf50',
    LblClass: 'lbl-approved',
    ForeColor: '#ffffff',
    isCatalog: true,
    Message: 'Task completed successfully.'
  },
  {
    Name: 'Failed',
    Value: 'Failed',
    Id: 6,
    LblClass: 'lbl-delete',
    Color: '#F44336',
    ForeColor: '#ffffff',
    isCatalog: true,
    Message: 'Task execution failed.'
  },
  {
    Name: 'Rejected',
    Value: 'Rejected',
    Id: 7,
    LblClass: 'lbl-rejected',
    Color: '#9C27B0',
    ForeColor: '#ffffff',
    isCatalog: true,
    Message: 'Task was rejected and will not be executed.'
  },
  {
    Name: 'Skipped',
    Value: 'Skipped',
    LblClass: 'lbl-pending-approval',
    Id: 8,
    Color: '#ffc107',
    ForeColor: '#000000',
    isCatalog: true,
    Message: 'Task was skipped based on defined conditions.'
  },
  {
    Name: 'RollbackInProgress',
    Value: 'Rollback In Progress',
    Id: 9,
    Color: '#00BCD4',
    LblClass: 'lbl-initiated',
    ForeColor: '#ffffff',
    isCatalog: true,
    Message: 'Rollback is in progress. Logs will appear shortly.'
  },
  {
    Name: 'Rollback',
    Value: 'Rollback',
    Id: 10,
    LblClass: 'lbl-delete',
    Color: '#9C27B0',
    ForeColor: '#ffffff',
    isCatalog: true,
    Message: 'Rollback completed.'
  },
  {
    Name: 'DeleteInProgress',
    Value: 'Delete In Progress',
    Id: 11,
    Color: '#00BCD4',
    LblClass: 'lbl-initiated',
    ForeColor: '#ffffff',
    isCatalog: true,
    Message: 'Deletion in progress. Logs will appear shortly.'
  },
  {
    Name: 'Deleted',
    Value: 'Deleted',
    Id: 12,
    LblClass: 'lbl-rejected',
    Color: '#F44336 ',
    ForeColor: '#ffffff',
    isCatalog: true,
    Message: 'Task has been deleted successfully.'
  }
];

export const GlobalConsoleState = [
  {
    Name: 'Created',
    Value: 'Created',
    Id: 0,
    Color: '#00BCD4',
    LblClass: 'lbl-initiated',
    ForeColor: '#ffffff'
  },
  {
    Name: 'InQueue',
    Value: 'In Queue',
    Id: 1,
    Color: '#22ccff',
    LblClass: 'lbl-sync',
    ForeColor: '#ffffff'
  },
  {
    Name: 'Processing',
    Value: 'Processing',
    Id: 2,
    Color: '#4caf50',
    LblClass: 'lbl-approved',
    ForeColor: '#ffffff'
  },
  {
    Name: 'Paused',
    Value: 'Paused',
    Id: 3,
    Color: '#22ffd6',
    LblClass: 'lbl-running',
    ForeColor: '#000000',
    isCatalog: false
  },
  {
    Name: 'Resumed',
    Value: 'Resumed',
    Id: 4,
    LblClass: 'lbl-rejected',
    Color: '#9C27B0',
    ForeColor: '#ffffff',
    isCatalog: true
  },
  {
    Name: 'Completed',
    Value: 'Completed',
    Id: 5,
    Color: '#22ffd6',
    LblClass: 'lbl-running',
    ForeColor: '#000000',
    isCatalog: false
  },
  {
    Name: 'Failed',
    Value: 'Failed',
    Id: 6,
    LblClass: 'lbl-delete',
    Color: '#F44336',
    ForeColor: '#ffffff',
    isCatalog: false
  },
  {
    Name: 'Cancelled',
    Value: 'Cancelled',
    Id: 7,
    LblClass: 'lbl-delete',
    Color: '#F44336',
    ForeColor: '#ffffff',
    isCatalog: false
  },
  {
    Name: 'Archived',
    Value: 'Archived',
    Id: 8,
    LblClass: 'lbl-delete',
    Color: '#F44336',
    ForeColor: '#ffffff',
    isCatalog: false
  }
];

export const DeveloperState = [
  {
    Name: 'Validated',
    Value: 'Validated',
    Id: 0,
    Color: '#4caf50',
    LblClass: 'lbl-approved',
    ForeColor: '#ffffff'
  },
  {
    Name: 'Added',
    Value: 'Added',
    Id: 1,
    Color: '#4caf50',
    LblClass: 'lbl-approved',
    ForeColor: '#ffffff'
  },
  {
    Name: 'In Review',
    Value: 'InReview',
    Id: 2,
    Color: '#ffc107',
    LblClass: 'lbl-pending-approval',
    ForeColor: '#000000',
    isCatalog: false
  },
  {
    Name: 'Reviewed',
    Value: 'Reviewed',
    Id: 3,
    Color: '#4caf50',
    LblClass: 'lbl-approved',
    ForeColor: '#ffffff',
    isCatalog: false
  },
  {
    Name: 'In Validation',
    Value: 'InValidation',
    Id: 4,
    Color: '#22ccff',
    LblClass: 'lbl-sync',
    ForeColor: '#ffffff',
    isCatalog: false
  }
];

export const ExecutionCommand = [
  {
    Name: 'InQueue',
    Value: 'In Queue',
    Id: 1,
    Color: '#22ccff',
    LblClass: 'lbl-sync',
    ForeColor: '#ffffff'
  },
  {
    Name: 'Success',
    Value: 'Success',
    Id: 5,
    Color: '#4caf50',
    LblClass: 'lbl-approved',
    ForeColor: '#ffffff',
    isCatalog: false
  },
  {
    Name: 'Failed',
    Value: 'Failed',
    Id: 6,
    LblClass: 'lbl-delete',
    Color: '#F44336',
    ForeColor: '#ffffff',
    isCatalog: false
  }
];

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BluePrintStateService {
  constructor() {}

  getState(Id: number) {
    return BluePrintState.find((d) => d.Id === Id);
  }

  getRole(Id: string) {
    return UserRole.find((d) => d.Id === Id);
  }

  getErrorState(Id: number) {
    return BluePrintErrorState.find((d) => d.Id === Id);
  }

  getErrorType(Id: number) {
    return BluePrintErrorType.find((d) => d.Id === Id);
  }

  getErrorSource(Id: number) {
    return BluePrintErrorSource.find((d) => d.Id === Id);
  }

  getWorkflowTaskState(Id: number) {
    return WorkflowTaskState.find((d) => d.Id === Id);
  }
  
  getGlobalConsoleState(Id: number) {
    return GlobalConsoleState.find((d) => d.Id === Id);
  }

  getDeveloperStatus(Id:number){
    return DeveloperState.find((d)=>d.Id === Id);
  }

  getExecuteCommandState(Id:number){
    return ExecutionCommand.find((d)=>d.Id === Id);
  }
}
